import { Component, Input, OnInit, inject } from '@angular/core';
import { ProviderOffice } from 'app/core/models/provider-office.model';
import { Provider } from 'app/core/models/provider.model';
import { keyedStatusOptions as keyedProviderStatusOptions } from 'app/core/options/provider-status.opts';
import { keyedStatusOptions as keyedOfficeStatusOptions } from 'app/core/options/office-status.opts';
import { keyedStatusOptions as keyedProviderOfficeStatusOptions } from 'app/core/options/provider-office-status.opts';
import { Office } from 'app/core/models/office.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Note } from 'app/core/models/note.model';

import { OfficeComponent } from '../office/office.component';
import { NotesForModelComponent } from '../notes-for-model/notes-for-model.component';
import { BlankValueDashPipe } from '../../pipes/blank-value-dash.pipe';
import { ListProviderOffice } from 'app/core/models/list-provider-office.model';
import { ProviderService } from 'app/core/services/provider.service';
import { OfficeService } from 'app/core/services/office.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-provider-office-association-notes-modal',
  templateUrl: './provider-office-association-notes-modal.component.html',
  styleUrls: ['./provider-office-association-notes-modal.component.scss'],
  imports: [OfficeComponent, NotesForModelComponent, BlankValueDashPipe, MatProgressSpinner]
})
export class ProviderOfficeAssociationNotesModalComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private providerService = inject(ProviderService);
  private officeService = inject(OfficeService);

  @Input() providerOffice: ProviderOffice | ListProviderOffice;

  provider: Provider;
  office: Office;
  loadingProvider = true;
  loadingOffice = true;
  changes = false;

  keyedProviderStatusOptions = keyedProviderStatusOptions;
  keyedOfficeStatusOptions = keyedOfficeStatusOptions;
  keyedProviderOfficeStatusOptions = keyedProviderOfficeStatusOptions;

  ngOnInit(): void {
    this.loadProviderIfNeeded();
    this.loadOfficeIfNeeded();
  }

  onNoteAdded(_note: Note) {
    this.changes = true;
  }

  onCloseClick() {
    this.activeModal.close(this.changes);
  }

  private loadProviderIfNeeded() {
    if ('provider' in this.providerOffice) {
      this.provider = this.providerOffice.provider;
      this.loadingProvider = false;
    } else {
      this.providerService.get(this.providerOffice.providerId).subscribe(provider => {
        this.provider = provider;
        this.loadingProvider = false;
      })
    }
  }

  private loadOfficeIfNeeded() {
    if ('office' in this.providerOffice) {
      this.office = this.providerOffice.office;
      this.loadingOffice = false;
    } else {
      this.officeService.get(this.providerOffice.officeId.toString()).subscribe(office => {
        this.office = office;
        this.loadingOffice = false;
      })
    }
  }
}
